import runAccessibility from "@/views/menu/runAccessibility";
import { renderWidget } from "@/views/widget/widget"

import { 
    userSettings,
    getSavedUserSettings
} from '@/globals/userSettings';

import { changeLanguage } from "./i18n/changeLanguage";
import { getDefaultLanguage } from "./i18n/getDefaultLanguage";

/**
 * Interface for the accessibility widget return object
 */
export interface AccessibilityWidget {
    changeLanguage: typeof changeLanguage;
}
function yieldToMain () {
    if ('scheduler' in window && 'yield' in (window as any).scheduler) {
      return (window as any).scheduler.yield();
    }
  
    return new Promise(resolve => {
      setTimeout(resolve, 0);
    });
  }
/**
 * Main accessibility widget initialization function
 * @returns Object with widget methods
 */
export default function accessibilityWidget(): AccessibilityWidget {
    try {
        // Load saved user settings
        const savedSettings = getSavedUserSettings();
        console.log('Default language:', getDefaultLanguage());
        
        // Merge saved settings with current settings
        Object.assign(userSettings, savedSettings);
        
        // Initialize language if not already set
        if (!userSettings.lang) {
            userSettings.lang = getDefaultLanguage();
        }
        yieldToMain
        // Initialize accessibility features
        runAccessibility();
        
        // Render the widget UI
        renderWidget();

        return {
            changeLanguage
        };
    } catch (error) {
        console.error('Failed to initialize accessibility widget:', error);
        
        // Return minimal interface even if initialization fails
        return {
            changeLanguage
        };
    }
}